/* eslint-disable no-useless-catch */
/* eslint-disable no-control-regex */
// @ts-ignore
import { includes, pathOr } from "ramda";
import Vue from "vue";
import { router } from "@/main";
import { store } from "@/main";
import DOMPurify from "isomorphic-dompurify";
// @ts-ignore
const vm = Vue.prototype;
// @ts-ignore
import { v4 as uuid } from "uuid";

export function random(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array: any) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};
export const range = (start: any, end: any, step: any = 1) => {
  const len = Math.floor((end - start) / step) + 1;
  return Array(len)
    .fill(undefined, undefined, undefined)
    .map((_, idx: any) => start + idx * step);
};
export const nl2br = (str: string) => {
  return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
};
export const copy = (text: string, notify = false) => {
  const el = document.createElement("textarea");
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  notify && vm.$notify.success(`متن "${text}" کپی شد`);
};
export const priceFormat = (value: number, currency: string = "") => {
  let output = `${Number(value || 0).toLocaleString()} ${currency}`;
  output = currency ? `${output} ${currency}` : output;
  return output.trim();
};
export const addOrEditMetaTagToHead = (
  tagName: any,
  content: string = "",
  isEdit: boolean = false
) => {
  if (isEdit) {
    document.getElementsByTagName("meta")[tagName].content = "";
    return;
  }
  var tag = document.createElement("meta");
  tag.setAttribute("name", tagName);
  tag.content = content;
  document.getElementsByTagName("head")[0].appendChild(tag);
};
export const checkEnumeration = () => {
  if (!localStorage.getItem("enumerations")) {
    // @ts-ignore
    store.dispatch("getAllEnumeration", true);
  }
};
export const checkIsEditableEnum = (enumName: string) => {
  const enumerations =
    JSON.parse(localStorage.getItem("enumerations") || "") || [];
  const item = enumerations.find((row: any) => row.category_name === enumName);
  return pathOr(false, ["is_editable"], item);
};
export const renderEumOptions = (
  enumName: string,
  idTruck: boolean = false
) => {
  checkEnumeration();
  const enumerations =
    JSON.parse(localStorage.getItem("enumerations") || "") || [];
  const item = enumerations.find((row: any) => row.category_name === enumName);
  const itemChild = [...pathOr([], ["child"], item)];
  return [...itemChild.map((item) => renderEnumItemFormat(item, idTruck))];
};
export const renderEumChildOptions = (
  enumItemId: any,
  idTruck: boolean = false
) => {
  checkEnumeration();
  const enumerations = JSON.parse(localStorage.getItem("enumerations") || "");
  const childOptions: any = [];
  for (let i = 0; i < enumerations.length; i++) {
    const childArr = [...pathOr([], ["child"], enumerations[i])];
    childArr.forEach((item) => {
      if (pathOr(null, ["parent_id"], item) === enumItemId) {
        childOptions.push(renderEnumItemFormat(item, idTruck));
      }
    });
  }
  return childOptions;
};
export const renderEnumItemFormat = (item: any, idTruck: boolean = false) => {
  return idTruck
    ? {
        id: pathOr(null, ["id"], item),
        caption: pathOr(null, ["caption"], item),
        category_id: pathOr(null, ["category_id"], item),
        is_default: pathOr(false, ["is_default"], item),
      }
    : {
        value: pathOr(null, ["id"], item),
        text: pathOr(null, ["caption"], item),
        category_id: pathOr(null, ["category_id"], item),
        is_default: pathOr(false, ["is_default"], item),
      };
};
export const renderEumOptionsSelected = (
  enumName: string,
  selectedValue: any
) => {
  // not used: will delete this method, but first check in all project
  return renderEumOptions(enumName).find((row) => row.value === selectedValue);
};
export const fullScreen = (elemId: String) => {
  if (elemId) {
    const elem: any = document.getElementById(`${elemId}`);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else {
      elem.exitFullscreen();
    }
  }
  return true;
};
export const checkPersianChar = (str: String = "", ev: any) => {
  const regex = new RegExp(/[^\x00-\x7E]/);
  if (ev.keyCode == 8 || ev.keyCode == 46) return false;
  if (str && str.length == 1 && str.match(regex)) {
    vm.$notify.error(vm.$lang.persion_caracter);
  }
};
export const checkPersianCharValidation = (str: any = null) => {
  if (!str) return;
  const regex = new RegExp(/[^\x00-\x7E]/);
  return str.match(regex);
};
export const checkMobileValidation = (str: String = "") => {
  var regex = new RegExp("^(\\+98|0)?9\\d{9}$");
  return str.match(regex);
};
export const convertUrlToBase64 = (url: any, callback: Function) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  xhr.responseType = "blob";
  xhr.send();
};
export const checkActiveParvandeh = (refreshing = true) => {
  try {
    const activeParvandeh = JSON.parse(
      localStorage.getItem("activeParvandeh") || ""
    );
    const province = pathOr(null, ["province"], activeParvandeh);
    const status = pathOr(null, ["status"], activeParvandeh);
    const code = pathOr(null, ["code"], activeParvandeh);
    refreshing && !code && refreshActiveParvandeh();
    return { code, province, status };
  } catch (error) {
    refreshing && refreshActiveParvandeh();
    return null;
  }
};
const refreshActiveParvandeh = async () => {
  try {
    // @ts-ignore
    await store.dispatch("getRegistrationCourses");
    const numParvandeh = JSON.parse(
      localStorage.getItem("numParvandeh") || "0"
    );
    if (numParvandeh > 1) {
      // @ts-ignore
      vm.$notify.warning(vm.$lang.force_select_parvandeh_message);
      // @ts-ignore
      router.push({ name: "registration-courses" });
    }
  } catch (error) {
    // @ts-ignore
    vm.$notify.warning(vm.$lang.force_select_parvandeh_message);
    // @ts-ignore
    router.push({ name: "registration-courses" });
  }
};
export const generateExpireTime = (exTime: any) => {
  /* guidance: if exTime parameter is not a time => generate time 5 minute by default */
  const nowTime = new Date();
  const expireTime = exTime
    ? new Date(exTime).getTime()
    : nowTime.getTime() + 300000;
  return Math.round((expireTime - nowTime.getTime()) / 1000);
};
export const checkExpiredTime = (date: any, limitDay: number = 1) => {
  const limit = limitDay * 86400;
  const now = new Date().getTime();
  const anotherDate = new Date(date).getTime();
  return Math.round((now - anotherDate) / 1000) > limit;
};
export const calcPercentage = (
  total: number = 0,
  inCompleteCount: number = 0
) => {
  return Math.round((100 / total) * (total - inCompleteCount)) || 0;
};
export const isAdmin = (permission = [], allowed = null) => {
  // const roles = pathOr([], ["state", "profile", "userInfo", "roles"], store );
  const allowedArr = allowed || ["admin", "edit"];
  // const permissions = [...roles, ...permission]
  return allowedArr.some((item) => includes(item, permission));
};
export const checkNotNeededService = (methodName: any) => {
  /* guidance: check not needed service name in current route */

  if (!methodName) return false;
  // @ts-ignore
  const currentRouteName = router.history.current.name;
  const configObj = {
    getMenu: ["azmoon_execute_exam_pack"],
    getUserInfo: ["azmoon_execute_exam_pack"],
  };
  // @ts-ignore
  return includes(currentRouteName, configObj[methodName]);
};
export const downloadBlob = (data: any, downloadFileName: string = "") => {
  return new Promise((resolve, reject) => {
    try {
      const fileName = downloadFileName || uuid();
      // Check the Browser.
      // @ts-ignore
      const isIE = false || !!document.documentMode;
      if (isIE) {
        // @ts-ignore
        window.navigator.msSaveBlob(data, fileName);
      } else {
        const url = window.URL || window.webkitURL;
        const link = document.createElement("a");
        link.href = url.createObjectURL(data);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve(true);
      }
    } catch (error) {
      reject(error);
    }
  });
};
export const generateApiUrl = (
  keys = [],
  replacement = [],
  queryString: any = {},
  baseUrl = ["api_url"]
) => {
  /* guidance: generate api url by keys and replacement values */
  let url = pathOr(null, baseUrl, vm.$config) + pathOr(null, keys, vm.$config);
  for (const key in replacement) {
    if (Object.prototype.hasOwnProperty.call(replacement, key)) {
      // replace values
      url = url.replace(`{${key}}`, replacement[key]);
    }
  }
  // add query strings to url
  url = generateQueryString(url, queryString);
  return url;
};
export const getProjectName = () => {
  return process.env.VUE_APP_PROJECT_NAME || "";
};
export const getWord = (
  str: string,
  num: number = 5,
  dots: boolean = false
) => {
  const toArr = str.split(" ");
  const output = toArr.filter((value, key) => key <= num - 1).join(" ");
  return dots ? `${output}...` : output;
};
export const isActiveSmsPanel = () => {
  return process.env.VUE_APP_ACTIVE_SMS_PANEL === "true" || false;
};
export const loginType = () => {
  return process.env.VUE_APP_LOGIN_TYPE || "user-pass";
};
export const setUniqueArrayOfObjects = (data: any, key: string) => {
  return [...new Map(data.map((item: any) => [item[key], item])).values()];
};
export const goToRoute = (
  name: string,
  params: object = {},
  query: object = {},
  newTab: boolean = true
) => {
  if (newTab) {
    // @ts-ignore
    const routeData = router.resolve({ name, params, query });
    window.open(routeData.href, "_blank");
  } else {
    // @ts-ignore
    router.push({ name, params, query }).catch(() => {});
  }
};
export const createDateFormat = (createdAt: string) => {
  if (!createdAt) return "";
  const date = createdAt.split(" ");
  return `<span class="mr-1">${date[0]}</span><span>${date[1]}</span>`;
};
export const checkCustomKey = (key: string, showDefault: boolean = true) => {
  return pathOr(showDefault, [key], vm.$customConfig);
};
export const checkFrontPageName = (data: any) => {
  const name = pathOr(null, ["front_page_name"], data);
  const allValidFrontPageNames = [
    "exam_pack_type_1",
    "exam_pack_type_2",
    "exam_pack_type_3",
    "exam_pack_interview",
    "analytical",
  ];
  return includes(name, allValidFrontPageNames);
};
export const checkActivePersonRelation = (item: any) => {
  // allow person relation when turn on key in custom config or this item has relation_count
  const relationCount = pathOr(0, ["relation_count"], item);
  return vm.$customConfig.isRegisterPersonRelation || relationCount;
};
export const justDigit = (str: any) => {
  // remove all characters except digits
  return str ? String(str).replaceAll(/\D/g, "").trim() : null;
};
export const storeDispatcher = async (
  key: string,
  value: any,
  module: any = null
) => {
  const source = module ? `${module}/setAction` : "setAction";
  // @ts-ignore
  await store.dispatch(source, { key, value });
};
export const checkNationalIdValidation = (nationalId: any) => {
  if (!nationalId) return true;
  if (nationalId.length != 10) return false;
  if (nationalId.substr(0, 3) == "000") return false;
  const invalidNumbers = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
  ];
  if (includes(nationalId, invalidNumbers)) return false;
  let check = 0;
  for (let i = 0; i < nationalId.length; i++) {
    const num = nationalId.substr(i, 1);
    check += num * (10 - i);
  }
  return !(check % 11);
};
export const checkNationalIdValidation2 = (val: any) => {
  if (!val) return true;

  const allDigitEqual = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
  ];
  const nationalCodePattern = /^([0-9]{10})+$/;
  if (allDigitEqual.indexOf(val) != -1 || !nationalCodePattern.test(val)) {
    return false;
  }
  const chArray = Array.from(String(val));
  const num0 = +chArray[0] * 10;
  const num2 = +chArray[1] * 9;
  const num3 = +chArray[2] * 8;
  const num4 = +chArray[3] * 7;
  const num5 = +chArray[4] * 6;
  const num6 = +chArray[5] * 5;
  const num7 = +chArray[6] * 4;
  const num8 = +chArray[7] * 3;
  const num9 = +chArray[8] * 2;
  const a = +chArray[9];
  const b = num0 + num2 + num3 + num4 + num5 + num6 + num7 + num8 + num9;
  const c = b % 11;
  return (c < 2 && a == c) || (c >= 2 && 11 - c == a);
};
export const logout = (shouldRefresh = false) => {
  localStorage.clear();
  goToRoute("auth", {}, {}, false);

  if (shouldRefresh) {
    // @ts-ignore
    const routeData = router.resolve({ name: "auth" });
    window.open(routeData.href);
  }
};
export const getActiveParvandeh = (key: any = null) => {
  const activeParvandeh = JSON.parse(
    localStorage.getItem("activeParvandeh") || ""
  );
  return key ? pathOr(null, key, activeParvandeh) : activeParvandeh;
};
export const getParvandehCount = () => {
  const parvandehCount = localStorage.getItem("parvandehCount") || 1;
  return parvandehCount;
};
export const checkPermission = (permission = [], allowed = null) => {
  const allowedArr = allowed || ["admin", "edit", "view"];
  return allowedArr.some((item) => includes(item, permission));
};
export const generateQueryString = (
  url: string = "",
  queryString: any = {}
) => {
  let output = url;
  const queryStringKeys = Object.keys(queryString);
  if (queryStringKeys.length) {
    output = `${output}?`;
    for (const key of queryStringKeys) {
      const value = queryString[key];
      if (value) {
        output = `${output}${key}=${value}&`;
      }
    }
    output = output.slice(0, -1); // remove last &
  }
  return output;
};
export const generateQueryStringWithKeysRepeat = (
  items: any = [],
  repeatKey: string = "repeatKey",
  extraQueryStrings: any = null
) => {
  // generate a query string when my query key is repeated
  let queryString = "?";
  for (const item of items) {
    queryString = `${queryString}${repeatKey}[]=${item}&`;
  }
  if (extraQueryStrings) {
    for (const [key, value] of Object.entries(extraQueryStrings)) {
      queryString += `${key}=${value}&`;
    }
  }
  queryString = queryString.slice(0, -1); // remove last & of queryString
  return queryString;
};
export const checkScreenDevice = (deviceArr: any = []) => {
  const screenSize = window.innerWidth;
  let screenDevice = "desktop";
  if (screenSize <= 991.98) {
    screenDevice = "tablet";
  }
  if (screenSize <= 575.98) {
    screenDevice = "mobile";
  }
  return includes(screenDevice, deviceArr);
};
export const generateIndicatorImage = (type: any, cls: string = "") => {
  if (!type) return "";
  const imageSrc =
    type === 1
      ? vm.$config.images.shared.redesign.successCircle
      : vm.$config.images.shared.redesign.errorCircle;
  return `<img src="${imageSrc}" class="${cls}"/>`;
};
export const toastAlert = (message: string, type: string = "success") => {
  vm.$notify[type](message);
};
export const generateError = (error: any) => {
  vm.$generateError(error);
};
export const generateLang = (key: any) => {
  return pathOr("", key, vm.$lang);
};
export const generateConfig = (key: any) => {
  return pathOr("", key, vm.$config);
};
export const renderAvatar = (
  data: any,
  type: string = "avatar",
  addressKey: string = "address"
) => {
  const imgKind = pathOr([], ["img_kind"], data);
  const imgItem = imgKind.find(
    (img: any) => pathOr(null, ["type"], img) === type
  );
  const address = pathOr(null, [addressKey], imgItem);
  return address || vm.$config.images.shared.redesign.empty.noUser;
};
export const generateCurrentRoute = (key: any = ["name"]) => {
  // @ts-ignore
  return pathOr(null, key, router.history.current);
};
export const generateRandomPassword = (
  length: number = 8,
  withSymbol: boolean = false
) => {
  const numbers = "0123456789";
  const letters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const symbols = "!@#$&";

  const getRandomChar = (chars: string) =>
    chars.charAt(Math.floor(Math.random() * chars.length));

  let mergedChars = "";
  // add chars
  for (let i = 0; i < 5; i++) {
    mergedChars += getRandomChar(letters);
  }
  // add numbers
  for (let i = 0; i < 4; i++) {
    mergedChars += getRandomChar(numbers);
  }
  // add symbols
  mergedChars += getRandomChar(symbols);

  // generated password
  let password = "";
  password = mergedChars
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return password;
};
export const generateStoreGetters = (key: Array<string>) => {
  // @ts-ignore
  return pathOr(null, key, store.getters);
};
export const sleep = (milliSeconds: number = 2000) => {
  return new Promise((resolve) => setTimeout(resolve, milliSeconds));
};
export const removeInArray = (removeItem: any, items: any) => {
  const index = items.findIndex((item: any) => item === removeItem);
  if (index !== -1) {
    items.splice(index, 1);
  }
};
export const removeItemInArray = (removeItem: any, items: any) => {
  const data = items;
  const index = data.findIndex((item: any) => item === removeItem);
  if (index !== -1) {
    data.splice(index, 1);
  }
  return data;
};
export const generateRouteLink = (
  name: string,
  params: object = {},
  query: object = {}
) => {
  // @ts-ignore
  const routeData = router.resolve({ name, params, query });
  return routeData.href;
};
export const generateFileType = (fileSuffix: string) => {
  if (includes(fileSuffix, ["jpg", "jpeg", "png", "bmp"])) {
    return "image";
  } else if (includes(fileSuffix, ["mp3", "webm", "ogg", "3gp"])) {
    return "audio";
  } else if (includes(fileSuffix, ["mp4", "wmv", "m4a", "wave"])) {
    return "video";
  } else if (includes(fileSuffix, ["pdf"])) {
    return "pdf";
  } else if (
    includes(fileSuffix, ["xls", "xlsx", "doc", "docx", "ppt", "pptx"])
  ) {
    return "document";
  } else {
    return "file";
  }
};
export const getCurrentDateTime = (format: string = "jYYYY/jMM/jDD HH:mm") => {
  return vm.$moment(new Date()).format(format);
};
export const generateUserData = (item: object) => {
  const downloadCode1 = pathOr(null, ["downloadCode"], item);
  const downloadCode2 = pathOr(null, ["download_code"], item);
  const downloadCode3 = pathOr(null, ["person", "download_code"], item);
  const personCode1 = pathOr(null, ["person", "code"], item);
  const personCode2 = pathOr(null, ["code"], item);
  const personCode3 = pathOr(null, ["person_code"], item);
  const personCode4 = pathOr(null, ["personCode"], item);
  const personCode5 = pathOr(null, ["parvandeh", "person", "code"], item);
  const parvandehCode1 = pathOr(null, ["parvandeh", "code"], item);
  const parvandehCode2 = pathOr(null, ["parvandeh", "parvandeh_code"], item);
  const parvandehCode3 = pathOr(null, ["parvandeh_code"], item);
  const parvandehCode4 = pathOr(null, ["person", "parvandeh_code"], item);
  const parvandehCode5 = pathOr(null, ["parvandehCode"], item);
  const parvandehCode6 = pathOr(null, ["parvandeh", "code"], item);
  const avatar1 = pathOr("", ["person", "image_address"], item);
  const avatar2 = pathOr("", ["image_address"], item);
  const avatar3 = pathOr("", ["image"], item);
  const avatar4 = pathOr("", ["person", "pic_url"], item);
  const fullName1 = pathOr("", ["person", "full_name"], item);
  const fullName2 = pathOr("", ["full_name"], item);
  const name = pathOr("", ["person", "name"], item);
  const family = pathOr("", ["person", "family"], item);
  const fullName3 = name && family ? `${name} ${family}` : "";
  const fullName4 = pathOr("", ["name"], item);
  const fullName5 = pathOr("", ["person", "name"], item);
  const fullName6 = pathOr("", ["fullName"], item);
  const name2 = pathOr("", ["parvandeh", "person", "name"], item);
  const family2 = pathOr("", ["parvandeh", "person", "family"], item);
  const fullName7 = name2 && family2 ? `${name2} ${family2}` : "";
  return {
    downloadCode: downloadCode1 || downloadCode2 || downloadCode3,
    personCode:
      personCode1 || personCode2 || personCode3 || personCode4 || personCode5,
    parvandehCode:
      parvandehCode1 ||
      parvandehCode2 ||
      parvandehCode3 ||
      parvandehCode4 ||
      parvandehCode5 ||
      parvandehCode6,
    avatar: avatar1 || avatar2 || avatar3 || avatar4,
    fullName:
      fullName1 ||
      fullName2 ||
      fullName3 ||
      fullName4 ||
      fullName5 ||
      fullName6 ||
      fullName7,
  };
};
export const generateFullName = (data: object) => {
  const name = pathOr("", ["name"], data);
  const family = pathOr("", ["family"], data);
  return [name, family].filter(Boolean).join(" ");
};
export const asyncLocalStorage = {
  setItem(key: string, value: string) {
    return Promise.resolve().then(() => localStorage.setItem(key, value));
  },
  getItem(key: string, isJasonParse = false) {
    const localStorageValue: any = localStorage.getItem(key);
    return Promise.resolve().then(() =>
      isJasonParse ? JSON.parse(localStorageValue) : localStorageValue
    );
  },
};
export const setAuthData = async (data: any) => {
  try {
    const tokenType = pathOr("bearer", ["token_type"], data);
    const accessToken = pathOr(null, ["access_token"], data);
    const refreshToken = pathOr(null, ["refresh_token"], data);
    const accessTokenExpiredAt = pathOr(0, ["access_token_expired_at"], data);
    const refreshTokenExpiredAt = pathOr(0, ["refresh_token_expired_at"], data);
    const createdAt = new Date().getTime();
    const authData = {
      tokenType,
      accessToken,
      refreshToken,
      accessTokenExpiredAt,
      refreshTokenExpiredAt,
      createdAt,
    };
    await asyncLocalStorage.setItem("authData", JSON.stringify(authData));
  } catch (e) {
    //
  }
};
export const getAuthData = async () => {
  try {
    const localStorageData = await asyncLocalStorage.getItem("authData");
    if (!localStorageData) return null;
    const authData = JSON.parse(localStorageData || "") || {};

    return authData;
  } catch (e) {
    return null;
  }
};
export const checkAuthenticated = async () => {
  try {
    const activeParvandeh = await asyncLocalStorage.getItem("activeParvandeh");
    if (!activeParvandeh) return false;
    const activeParvandehData = JSON.parse(activeParvandeh || "") || {};
    return !!activeParvandehData;
  } catch (e) {
    return false;
  }
};
export const checkActiveTokens = async () => {
  try {
    const authData = await getAuthData();
    const accessTokenExpiredAt = pathOr(0, ["accessTokenExpiredAt"], authData);
    const refreshTokenExpiredAt = pathOr(
      0,
      ["refreshTokenExpiredAt"],
      authData
    );
    const createdAt = pathOr(0, ["createdAt"], authData);
    const nowTime = new Date().getTime();
    const diffTime = nowTime - createdAt;

    // check expired refresh token
    const isActiveRefreshToken = refreshTokenExpiredAt > diffTime;
    if (authData && !isActiveRefreshToken) {
      localStorage.clear();
      goToRoute("auth", {}, {}, false);
      location.reload();
      return false;
    }

    // check expired access token
    const isActiveAccessToken = accessTokenExpiredAt > diffTime;
    return isActiveAccessToken;
  } catch (e) {
    return false;
  }
};
export const getCurrentQueryString = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const queryString: any = {};
  for (const [key, value] of urlParams) {
    queryString[key] = value;
  }
  return queryString;
};

export const createPureDom = (encodedHtml: any) => {
  const tempElement = document.createElement("textarea");
  tempElement.innerHTML = encodedHtml;
  const decodedHtml = tempElement.value;
  const clean = DOMPurify.sanitize(decodedHtml);
  return clean;
};
